import { customStyles } from '~/Styles/reactSelectStyles';

export const selectStyles = {
  ...customStyles,
  control: (base, state) => ({
    ...base,
    minHeight: '38px',
    borderRadius: '4px',
    fontFamily: "'Open Sans', Arial, sans-serif",
    boxShadow: state.isFocused ? '0 0 0 0.2rem rgba(0,123,255,.25)' : 'none',
  }),
  valueContainer: base => ({
    ...base,
    padding: '0 8px',
  }),
  input: base => ({
    ...base,
    margin: 0,
    padding: 0,
  }),
};
